// English language pack
export default {
  '页面标题': 'Dongfeng eπ',
  '加载中...': 'Loading...',
  '车型': 'Models',
  '技术': 'Technology',
  '零售中心': 'Retail Centers',
  '服务中心': 'Service Centers',
  '关于我们': 'About Us',
  '其他工具': 'Tools',
  '预订': 'Reserve',
  '预约试驾': 'Test drive',
  '请登录': 'Sign In',
  '关闭菜单': 'Close menu',
  '菜单': 'Menu',
  '关闭': 'Close',
  '邮箱登录': 'Email Sign In',
  '手机号登录': 'Mobile Sign In',
  '请输入邮箱': 'Enter email',
  '请输入手机号': 'Enter mobile number',
  '请输入密码(6~12位字母+数字)': 'Enter password (6–12 letters and numbers)',
  '登录': 'Sign In',
  '注册账号': 'Create Account',
  '忘记密码': 'Forgot password',
  '其他登录方式': 'Other sign-in methods',
  '我已阅读并同意': 'I have read and agree to',
  '与': 'and',
  '《用户注册协议》': 'User Registration Agreement',
  '《隐私政策》': 'Privacy Policy',
  '微信二维码': 'WeChat QR Code',
  '东风自研': 'Dongfeng Innovation',
  '革新技术': 'Advanced Technology',
  '东风快讯': 'Dongfeng News',
  '联系我们': 'Contact Us',
  '车型参数对比': 'Model Comparison',
  '个人中心': 'Account Center',
  '个人信息': 'Profile',
  '我的预订': 'My Reservations',
  '我的预约试驾': 'My Test Drives',
  '退出登录': 'Sign Out',
  '简体中文': 'Simplified Chinese',
  '繁體中文': 'Traditional Chinese',
  'English': 'English',
  '语言': 'Language',
  '邮箱': 'Email',
  '手机号': 'Mobile number',
  '密码': 'Password',
  '请输入密码': 'Enter password',
  '用户协议': 'User Agreement',
  '和': 'and',
  '隐私条款': 'Privacy Terms',
  '请输入手机号码': 'Enter mobile number',
  '登录密码': 'Sign-in password',
  '验证码登录': 'Sign in with verification code',
  '验证码': 'Verification code',
  '请输入验证码': 'Enter verification code',
  '密码登录': 'Sign in with password',
  '注册登录即同意': 'By signing in or registering, you agree to',
  '验证码请求失败，请重试': 'Could not request a verification code. Please try again.',
  '请阅读并同意遵守《用户协议》': 'Please read and agree to the User Agreement.',
  '手机号不能为空': 'Mobile number is required.',
  '邮箱不能为空': 'Email is required.',
  '邮箱错误': 'Please enter a valid email address.',
  '密码不能为空': 'Password is required.',
  '密码必须为6~12位字母加数字的组合': 'Password must be 6–12 letters and numbers.',
  '登录信息异常，请重试': 'Sign-in information is invalid. Please try again.',
  '获取用户信息失败': 'Failed to retrieve user information.',
  '登录成功': 'Signed in successfully.',
  '登录失败': 'Sign-in failed.',
  '登录失败，请稍后重试': 'Sign-in failed. Please try again later.',
  '获取验证码': 'Send code',
  '{count}s后重新获取': 'Resend in {count}s',
  '注册': 'Register', '使用手机号注册': 'Register with mobile number',
  '使用邮箱注册': 'Register with email',
  '已有账号，前去登录': 'Already have an account? Sign in',
  '请输入正确的邮箱格式': 'Please enter a valid email address.',
  '注册成功，去登录': 'Registration successful. Please sign in.',
  '注册失败': 'Registration failed.',
  '请输入新密码(6~12位字母+数字)': 'Enter new password (6–12 letters and numbers)',
  '确定': 'Confirm',
  '使用手机号找回': 'Recover with mobile number',
  '使用邮箱找回': 'Recover with email',
  '返回': 'Back',
  '新密码': 'New password',
  '验证码不能为空': 'Verification code is required.',
  '修改成功，去登录': 'Password updated. Please sign in.',
  '修改失败': 'Update failed.',
  '售价': 'Price',
  '万元': '10,000 yuan',
  '万元起': '10,000 yuan and up',
  '详情': 'Details',
  '查看详情': 'Details',
  '了解更多': 'Learn More',
  '上一张': 'Previous slide',
  '下一张': 'Next slide',
  '切换到第{count}张': 'Go to slide {count}',
  '观看完整视频': 'Watch Full Video',
  '关闭视频': 'Close video',
  '品牌故事完整视频': 'Brand Story Full Video',
  '东风家族 匠心之作': 'Dongfeng Family, Crafted with Care',
  '以科技与美学重新定义出行体验': 'Redefining mobility through technology and aesthetics',
  '品牌故事': 'Brand Story', '见证东风与时代同行的每一步': 'Witness every step Dongfeng takes alongside the times',
  '探索东风科技': 'Explore Dongfeng Technology',
  '智能 · 电动 · 安全，驱动未来出行': 'Intelligent · Electric · Safe — Driving Future Mobility',
  '感受东风服务': 'Experience Dongfeng Service',
  '全程陪伴，让每一程更安心': 'With you throughout every journey, for greater peace of mind',
  '关怀、品质、智慧、平台': 'Care, Quality, Intelligence, Platform',
  '立即预定': 'Reserve Now',
  '播放视频': 'Play video',
  '观看视频': 'Watch video',
  '上一张外观图': 'Previous exterior image',
  '下一张外观图': 'Next exterior image',
  '切换到第{count}张外观图': 'Go to exterior image {count}',
  '上一张内饰图': 'Previous interior image',
  '下一张内饰图': 'Next interior image',
  '切换到第{count}张内饰图': 'Go to interior image {count}',
  '上一页': 'Previous page',
  '下一页': 'Next page',
  '第{count}页': 'Page {count}',
  '更多功能与场景': 'More Features and Scenarios',
  '车型详情加载失败，请稍后重试': 'Could not load vehicle details. Please try again later.',
  '车型选择': 'Select Models',
  '请选择': 'Please select',
  '全国统一零售价': 'National Recommended Retail Price',
  '基础参数': 'Basic Specifications',
  '长度': 'Length',
  '宽度': 'Width',
  '高度': 'Height',
  '轴距': 'Wheelbase',
  '座位数': 'Number of Seats',
  '座位布局': 'Seat Layout',
  'CLTC综合工况续航里程': 'CLTC Combined Range',
  '5C超充时间': '5C Fast-Charging Time',
  '风阻系数': 'Drag Coefficient',
  '电动系统': 'Electric System',
  '高压纯电平台': 'High-Voltage Pure-Electric Platform',
  '动力电池类型': 'Traction Battery Type',
  '动力电池总电量': 'Total Battery Capacity',
  'CLTC综合工况能耗': 'CLTC Energy Consumption',
  '5C超充功率': '5C Fast-Charging Power',
  '外观与内饰': 'Exterior and Interior',
  '车漆颜色': 'Paint Colors',
  '增程电动平台': 'Range-Extended Electric Platform',
  '增程器': 'Range Extender',
  '增程器长周期保养': 'Long-Interval Range Extender Maintenance',
  'CLTC纯电续航里程': 'CLTC Pure-Electric Range',
  'WLTC纯电续航里程': 'WLTC Pure-Electric Range',
  '已包含': 'Included',
  '已购': 'Purchased',
  '选购': 'Select',
  '外观内饰': 'Exterior',
  '选装配置': 'Optional',
  '外观': 'Exterior',
  '外观套件': 'Exterior Package',
  '轮毂': 'Wheels',
  '内饰': 'Interior',
  '此时下单，预计10-12周内交付': 'Order now for estimated delivery in 10–12 weeks',
  '选装': 'Options',
  '确定预定': 'Confirm',
  '确定预订': 'Confirm',
  '明细清单': 'Itemized Summary',
  '购车总价': 'Total Vehicle Price',
  '继续选配': 'Continue Selecting',
  '请填写您的预订信息': 'Please Fill in Your Reservation Details',
  '购车类型': 'Buyer Type',
  '购车方案': 'Payment',
  '姓名': 'Name',
  '请输入': 'Please enter',
  '证件类型': 'ID Type',
  '证件号码': 'ID Number',
  '取车门店': 'Pickup Store',
  '国家': 'Country',
  '省份': 'Province',
  '选择门店': 'Select a Store',
  '预订须知': 'Reservation Notice',
  '明细': 'Details',
  '个人': 'Individual',
  '企业': 'Business',
  '居民身份证': 'Resident ID Card',
  '护照': 'Passport',
  '全款': 'Cash',
  '金融分期': 'Finance',
  '取消': 'Cancel',
  '请选择国家': 'Select a Country',
  '请选择省份': 'Select a Province',
  '请选择门店': 'Select a Store',
  '预订成功!': 'Reservation Successful!',
  '已将您的预订需求发送至门店，请留意官方人员来电': 'Your reservation has been sent to the store. Please expect a call from an official representative.',
  '查看订单': 'View Order',
  '地区列表加载失败，请稍后重试': 'Could not load the region list. Please try again later.',
  '门店列表加载失败，请稍后重试': 'Could not load the store list. Please try again later.',
  '请输入姓名': 'Please enter your name', '请输入证件号码': 'Please enter your ID number',
  '请选择取车门店': 'Please select a pickup store',
  '车型信息缺失，请返回重新选择车型': 'Vehicle information is missing. Please return and select a vehicle again.',
  '选配信息缺失，请返回重新选择配置': 'Option information is missing. Please return and select options again.',
  '预订提交失败，请重试': 'Reservation submission failed. Please try again.',
  '奕派智能空间': 'eπ Intelligent Space',
  '智能黄金标准': 'The Gold Standard of Intelligence',
  '智能满配体验': 'A Fully Equipped Intelligent Experience',
  '真好用， 安全、 便捷又易用': 'Truly Useful, Safe, Convenient and Easy to Use',
  '原生智能，定义座舱新标杆': 'Native intelligence, setting a new cockpit benchmark',
  '此处是一则标题': 'Sample Title',
  '标题配置': 'Title Configuration',
  '搭载无瑕星环剧院音响系统，29个座舱扬声器、4个头枕扬声器，峰值总功率5440W，9.3.6双全景声环绕，声声悦耳。': 'Equipped with a pristine star-ring theater sound system: 29 cabin speakers, 4 headrest speakers, 5,440 W peak output, and 9.3.6 panoramic surround sound.',
  '27个智能感知硬件，1个舱内激光视觉Limera，3个4D毫米波雷达，11个高精摄像头，12个超声波雷达': '27 intelligent sensing devices, 1 in-cabin LiDAR vision Limera, 3 4D millimeter-wave radars, 11 high-precision cameras and 12 ultrasonic radars.',
  '多模态感知': 'Multimodal Perception',
  '多模态感知与生成一体化模型，能通过视觉、语音、文字等多种方式认识世界，还能结合所在地点、时间，随时随地陪伴全家人。': 'An integrated perception-and-generation model understands the world through vision, voice and text, while considering location and time to accompany the whole family anywhere.',
  '灵活规划': 'Flexible Planning',
  '能根据语音、文本等信息，进行多模态融合规划。有强大的理解能力，可以对复杂任务进行拆解，分步调用工具，像人脑一样思考。': 'It plans by combining voice, text and other information, understands complex tasks, breaks them down and calls tools step by step—thinking like a human brain.',
  '自主行动': 'Autonomous Action',
  '处理复杂任务反应迅速、执行准确，与应用深度融合，能调用丰富内外部工具，表达自然拟人、有逻辑，遇到问题，放心交给它。': 'It responds quickly and executes complex tasks accurately, integrates deeply with apps and uses rich internal and external tools with natural, logical interaction.',
  '拟人对话': 'Human-like Conversation',
  '升级MindGPT-4o-preview端到端语音模型能力，有更丰富的音色，更类人的情绪表达，更有趣的聊天风格，还能更好的读懂你的心情。': 'Enhanced MindGPT-4o-preview end-to-end voice capabilities bring richer voices, more human emotion and a more engaging conversation style.',
  '双门双向智能冷暖箱': 'Dual-Door, Dual-Access Smart Cooler and Warmer',
  '-6°C~50°C宽温域|8.8L大容积': '-6°C to 50°C wide temperature range | 8.8 L capacity',
  '双视界大屏幕': 'Dual-View Large Displays',
  '16.1英寸3K华为中控屏   17.3英寸3K后排吸顶屏': '16.1-inch 3K Huawei center display | 17.3-inch 3K rear ceiling display',
  '同级最大50英寸AR-HUD': 'Class-Leading 50-inch AR-HUD', '实景路况指引，从容出行': 'Real-world road guidance for composed journeys', '全置换新风': 'Full Fresh-Air Replacement', '诺贝尔奖级MOFs尖端滤芯': 'Nobel Prize-level MOF advanced filter', '该技术详情暂未配置': 'This technology detail has not been configured yet.',
  '你好，我们是东风汽车': 'Hello, We Are Dongfeng Motor', '聚焦主流新能源市场为客户创造无限不循环的未来出行可能': 'Focused on the mainstream new-energy market, creating limitless future mobility possibilities for customers.', '东风奕派，智慧科技电动品牌': 'Dongfeng eπ, an Intelligent Electric Brand', '奕派科技承袭东风汽车企业使命': 'eπ Technology Carries Forward Dongfeng Motor\'s Mission', '让汽车驱动梦想': 'Let Cars Drive Dreams', '东风坚信，汽车始终是工业领域先进科技的集大成者，不仅仅是移动的工具已经成为家庭和工作之外的第三空间，拥有无限创新发展可能': 'Dongfeng believes that cars are the culmination of advanced industrial technology—not merely mobility tools, but a third space beyond home and work with unlimited potential for innovation.', '技术东风 科技随行 愉悦交互': 'Dongfeng Technology, Technology Alongside, Joyful Interaction', '天元智驾': 'Tianyuan Intelligent Driving', '天元智舱': 'Tianyuan Intelligent Cockpit', '信赖基石 品质无忧': 'Foundation of Trust, Quality Without Worry', '量子架构 核心技术坚持自研': 'Quantum Architecture, Core Technologies Developed In-house', '天元T100': 'Tianyuan T100', '实现L2级高速NOA、记忆领航辅助驾驶和跨层记忆泊车': 'Enabling L2 highway NOA, memory navigation assistance and multi-level memory parking.', '便捷': 'Convenient', '贴心': 'Thoughtful', '更懂你': 'Understands You Better', '满足全家人的需求交互更流畅': 'Meeting the whole family\'s needs with smoother interaction.', '多维拓展': 'Multidimensional Expansion', '低碳高效': 'Low-carbon and Efficient', '极致性能': 'Ultimate Performance', '匠心品质': 'Craftsmanship Quality', '风阻系数低至0.21低温续航衰减低至30%': 'Drag coefficient as low as 0.21 and low-temperature range loss as low as 30%.',
  '发布于': 'Published on ', '分页': 'Pagination', '新闻列表加载失败，请稍后重试': 'Could not load the news list. Please try again later.', '文章导航': 'Article navigation', '上一篇': 'Previous Article', '下一篇': 'Next Article', '列表': 'List', '返回列表': 'Back to List', '未找到该快讯': 'News item not found', '新闻详情加载失败，请稍后重试': 'Could not load the news detail. Please try again later.', '暂无': 'Not available',
  '试驾体验，不止于驾驶。': 'A test-drive experience that goes beyond driving.', '试驾车辆': 'Vehicle', '试驾门店': 'Dealership', '试驾人': 'Driver’s name', '先生': 'Mr.', '女士': 'Ms.', '立即预约': 'Book Now', '确定预约': 'Book a Test Drive', '选择车辆': 'Choose a Vehicle', '离您较近的门店': 'Nearby Dealerships', '查看全部门店': 'View All Dealerships',
  '试驾车': 'Test-drive vehicles',
  '展车': 'Display vehicles',
  '暂无服务内容': 'No service information available', '预约试驾成功': 'Test drive booked successfully', '预约试驾成功!': 'Test drive booked successfully!', '已将您的预约试驾申请发送至门店，请留意官方人员来电': 'Your test-drive request has been sent to your selected dealership. Our team will contact you shortly.', '知道了': 'Got It', '验证码发送失败，请重试': 'Could not send the verification code. Please try again.', '验证码已发送': 'Verification code sent', '请选择试驾车辆': 'Please select a vehicle', '请选择试驾门店': 'Please select a dealership', '请输入试驾人姓名': 'Please enter the driver’s name', '预约提交失败，请重试': 'We couldn’t submit your booking. Please try again.',
  '寻找离您最近的东风奕派门店': 'Find the Dongfeng eπ store nearest you',
  '请选择省': 'Select a province',
  '请选择市': 'Select a city',
  '选择所在地区': 'Select your location',
  '请选择省/市/区': 'Select a province, city, or district',
  '当前位置': 'Current location',
  '确认': 'Confirm',
  '我们友好且敬业的团队已准备好随时协助您解决任何需求并全程陪伴您左右！现在就联系我们吧。': 'Our friendly, dedicated team is ready to help with anything you need and support you every step of the way. Contact us today.',
  '暂无门店信息': 'No store information available',
  '头像': 'Profile picture',
  '上传中': 'Uploading',
  '修改头像': 'Change profile picture',
  '确定退出当前账号吗？': 'Are you sure you want to sign out?',
  '姓名不能为空': 'Name is required.',
  '姓名修改失败': 'Failed to update your name.',
  '姓名修改成功': 'Name updated successfully.',
  '姓名修改失败，请稍后重试': 'Failed to update your name. Please try again later.',
  '请选择图片文件': 'Please select an image file.',
  '头像上传失败': 'Failed to upload profile picture.',
  '头像修改失败': 'Failed to update profile picture.',
  '头像修改成功': 'Profile picture updated successfully.',
  '头像修改失败，请稍后重试': 'Failed to update profile picture. Please try again later.',
  '预订人：': 'Reserved by: ',
  '预订时间：': 'Reservation time: ',
  '预订门店：': 'Reservation store: ',
  '暂无预订记录': 'No reservation records',
  '预订列表加载失败，请稍后重试': 'Could not load reservation records. Please try again later.',
  '试驾人：': 'Driver: ',
  '试驾门店：': 'Dealership: ',
  '试驾时间：': 'Test-drive time: ',
  '暂无预约，去预约试驾喜欢的汽车吧~': 'No test drives yet. Book one for a car you love!',
  '去预约': 'Book Now',
  '待门店确认试驾时间': 'Awaiting store confirmation of the test-drive time',
  '预约试驾列表加载失败，请稍后重试': 'Could not load test-drive records. Please try again later.',
  '我的预订详情': 'My Reservation Details',
  '方案': 'Plan',
  '预订详情数据异常': 'Invalid reservation detail data.',
  '预订详情加载失败，请稍后重试': 'Could not load reservation details. Please try again later.',
  '查看课程': 'View Course', '城市地区': 'City / Region', '倒计时结束后再发送': 'Please wait for the countdown to finish before sending again.', '购买': 'Buy', '购物车': 'Shopping Cart', '回到顶部': 'Back to Top', '客服电话：{phone}': 'Customer Service: {phone}', '客服暂时无法连接，请稍后再试': 'Customer service is temporarily unavailable. Please try again later.', '快捷操作': 'Quick Actions', '联系客服': 'Contact Customer Service', '请输入护照姓名(英文)': 'Enter passport name (English)', '请输入使用者姓名(请填写实名)': 'Enter your name (use your legal name)', '请选择您的生日': 'Select your date of birth', '我的收藏': 'My Favorites', '移除': 'Remove', '隐私政策': 'Privacy Policy', '重新获取': 'Get Again',
  '请输入使用者姓名': 'Enter your name', '请选择地区': 'Select a region',
  '请选择所在地区': 'Select your location',
  '金融试算器': 'Finance Calculator',
  '车辆类型': 'Vehicle Type',
  '选择车型': 'Select a Model',
  '购车价格': 'Vehicle Price',
  '金融方案': 'Finance Plan',
  '贷款城市': 'Loan City',
  '贷款城市请选择您车辆的上牌城市': 'Please select the city where your vehicle will be registered.',
  '暂无适用金融产品': 'No finance products are currently available.',
  '首付比例': 'Down Payment Ratio',
  '分期期数': 'Installment Term',
  '金融试算明细': 'Finance Calculation Details',
  '预估首付': 'Estimated Down Payment',
  '贷款/融资金额': 'Loan / Financing Amount',
  '金融产品': 'Finance Product',
  '{count}期': '{count} installments',
  '预估月付': 'Estimated Monthly Payment',
  '利息': 'Interest',
  '年化费率': 'Annualized Rate',
  '近似年化利率{rate}%': 'Approximate annualized interest rate: {rate}%',
  '请选择车型': 'Select a Model',
  '暂无金融产品': 'No Finance Product',
  '未命名金融产品': 'Unnamed Finance Product',
  '金融机构': 'Financial Institution',
  '东风服务': 'Dongfeng Service',
  '服务指南': 'Service Guide',
  '超长质保': 'Extended Warranty',
  '整车5年或10万公里，三电8年或16万公里': '5 years or 100,000 km for the vehicle; 8 years or 160,000 km for the three-electric system.',
  '售后服务网络': 'After-sales Service Network',
  '覆盖200+城市，身边就有的服务中心。': 'Service centers in more than 200 cities, always close by.',
  '道路救援': 'Roadside Assistance',
  '整车质保期内，因车辆质量问题无法正常行驶时，<br>为您提供7*24小时便捷安心的救援服务。': 'During the vehicle warranty period, if a quality issue prevents normal driving,<br>we provide convenient, reassuring 24/7 roadside assistance.',
  '尊享服务': 'Premium Service',
  '理想整车延长保修服务，最高保障至8年或16万公里。<br>理想用车服务包，一包涵盖核心养车需求。': 'Extended vehicle warranty coverage for up to 8 years or 160,000 km.<br>A vehicle service package covering essential maintenance needs.',
  '专业线上服务': 'Professional Online Service',
  '官方客服、理想汽车App、电话等多渠道快速响应。': 'Quick responses through official customer service, the app, phone, and other channels.',
  '流量无忧': 'Worry-free Data',
  'OTA升级、车机导航等基础功能终身免流量。<br>赠送36个月、每月20GB娱乐流量。': 'Lifetime free data for essential functions such as OTA updates and in-car navigation.<br>Includes 20 GB of entertainment data per month for 36 months.',
  '智能用车助手': 'Smart Vehicle Assistant',
  '像和真人客服对话一样自然。咨询用车问题、查询车辆状态、诊断故障灯，理想同学都能理解，并给出图文或视频解答，解决每个人的用车疑惑。': 'As natural as speaking with a live agent. Ask vehicle questions, check vehicle status, or diagnose warning lights for clear text, image, or video answers.',
  '一站式技术支持与服务': 'One-stop Technical Support and Service',
  '多渠道在线，快速响应，及时解决您的用车问题。': 'Fast, responsive online support through multiple channels to resolve your vehicle issues promptly.',
  '专业维修服务中心': 'Professional Repair Service Center',
  '专家全程一对一服务，配合覆盖全国的取送车服务，有保障，也更靠谱。': 'One-to-one expert service, together with nationwide vehicle pickup and delivery, for dependable peace of mind.',
  '我的预定': 'Reservations',
  '零售与服务': 'Retail and Services',
  'Middle East Network': 'Middle East Network',
  '全新奕跑SHINE': '全新奕跑SHINE'
};
